import { cookieKeys, getCookie } from 'utils';
import { JWT_AUTH_ERRORS } from './constants';

export const getJwtErrorMessage = (): string => {
    const errorKey = getCookie(cookieKeys.JWT_AUTH_ERROR) as keyof typeof JWT_AUTH_ERRORS;

    return JWT_AUTH_ERRORS[errorKey] || '';
};
